import { useRef } from 'react';
import { useTranslation } from '@packages/utils';
import useElementResize from 'hooks/useElementResize';
import { Alert } from 'components/Base/Alert';
import { Table } from 'components/Base/Table';
import useNavigateWithBackState from 'hooks/useNavigateWithBackState';
import { TKitManagementParentUI } from 'data/types/kitManagement.types';
import { TParentBodyProps } from './ParentBody.types';

const ParentBody = ({
  showAlert,
  setShowAlert,
  dataSource,
  isFetching,
  totalDataCount,
  hasFilters,
  onFiltersReset,
  columns,
  pageSize,
  setPageSize,
  setSelectedRows,
  onChange,
  selectedRows,
  currentPage,
  storagePath,
}: TParentBodyProps) => {
  const { t } = useTranslation({
    keyPrefix: 'descriptions.admin-portal.parents.list',
  });
  const { goWorkshopDetails } = useNavigateWithBackState();

  const navigateToWorkshopDetails = (record: TKitManagementParentUI) => {
    return {
      onClick: () => goWorkshopDetails(record.workshopId, t('TITLE')),
    };
  };

  const alertRef = useRef<HTMLDivElement>(null);
  const { height: alertHeight } = useElementResize({
    ref: alertRef,
  });

  return (
    <>
      {/* added 1px minHeight to calculate alert height correctly when is
      shown/hidden */}
      <div ref={alertRef} className="mx-4" style={{ minHeight: '1px' }}>
        {showAlert && (
          <Alert
            type="warning"
            closable
            message={t('table.ACTION_ALERT_MESSAGE')}
            className="mt-4"
            onClose={() => setShowAlert(false)}
          />
        )}
      </div>
      <Table<TKitManagementParentUI>
        onRow={navigateToWorkshopDetails}
        onFiltersReset={onFiltersReset}
        hasFilters={hasFilters}
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        columns={columns}
        dataSource={dataSource}
        rowClassName="pointer"
        loading={isFetching}
        pageSize={pageSize}
        setPageSize={setPageSize}
        totalDataCount={totalDataCount}
        onChange={onChange}
        rowKey={record => record.parentOrderId}
        currentPage={currentPage}
        pageHeaderContent={alertHeight}
        storagePath={storagePath}
      />
    </>
  );
};

export default ParentBody;
